import React, { useState, useEffect } from 'react';
import Form from './components/Form';
import axios from 'axios';
import Navbar from './components/layout/Navbar';
import tensify from 'tensify';
//testing branch
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,

} from "react-router-dom";
import { FormContext } from './FormContext';
import moment from 'moment';
import * as EmailValidator from "email-validator";

// import './App.css';


function App() {

  const location = useLocation();
  const formId = new URLSearchParams(location.search).get('formId')
  const pageType = new URLSearchParams(location.search).get('pageType');
  console.log('pageType',pageType)
  const pageIndex = new URLSearchParams(location.search).get('pageIndex')
  const applicantId = new URLSearchParams(location.search).get('applicantId')
  const download = new URLSearchParams(location.search).get('download')

  //
  const [submitId, setSubmitId] = useState(null);
  const [submitTime, setSubmitTime] = useState(null);
  const [formStatus, setFormStatus] = useState(null)
  const [id, setId] = useState(null)
  const [formElements, setFormElements] = useState({});
  const [formBar, setFormBar] = useState(false)
  const [formBack, setFormBack] = useState(null)
  const [disableField, setDisableField] = useState(false);
  const [formAdmin, setFormAdmin] = useState(false);
  const [formOfficer, setFormOfficer] = useState(null);
  const [formApprovalIndex, setFormApprovalIndex] = useState(null);
  const [formUserLock, setFormUserLock] = useState(false);
  const [formPageType, setFormPageType] = useState(null)
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [formPagesDisplay, setFormPagesDisplay] = useState(null)
  const [formUserPage, setFormUserPage] = useState(null)
  const [disableUserSaveBtn, setDisableUserSaveBtn] = useState(false)
  const [formAdminProgress, setFormAdminProgress] = useState(true)
  const [formOfficialPage, setFormOfficialPage] = useState(null)
  const [customPages, setCustomPages] = useState(null)
  const [formCustomEnable, setFormCustomEnable] = useState(false)
  const [formAdminNoteEnable, setFormAdminNoteEnable] = useState(false)
  const [formCaptchaEnable, setFormCaptchaEnable] = useState(true)
  const [formUrl, setFormUrl] = useState(null)
  const [formPrintEnable, setFormPrintEnable] = useState(true)
  const [formNavLabel, setFormNavLabel] = useState(null)
  const [formMultipleType, setFormMultipleType] = useState(null)
  const [formChatPerson, setFormChatPerson] = useState(null)
  const [formOfficers, setFormOfficers] = useState([])
  const [isFormValid, setIsFormValid] = useState(true)
  //before changing to radio
  let baseAdminObj = {
    "page_label": "Administer",
    "page_type": "official",
    "page_user": "#page_user_1#",
    "parts": [
      {
        "fields": [
          {
            "field_id": "official_status_1",
            "field_label": "Status",
            "field_mandatory": "#mandatory_#page_user_1##",
            "field_options": [
              {
                "option_label": "Pending"
              },
              {
                "option_label": "Adminstered"
              },
              {
                "option_label": "Not Adminstered"
              },
              {
                "option_label": "Returned"
              }
            ],
            "field_type": "radio",
            "field_value": "Pending"
          },
          {
            "field_id": "official_remark_1",
            "field_label": "Remark",
            "field_type": "textarea",
            "field_value": ""
          },
          {
            "field_autocomplete": "User",
            "field_disabled_approver": "#approver_disabled_1#",
            "field_id": "approver_1",
            "field_label": "Signature",
            "field_mandatory": "#mandatory_#page_user_1##",
            "field_type": "text",
            "field_value": "#sign_#page_user_1##"
          },
          {
            "field_id": "sign_date_1",
            "field_label": "Date",
            "field_mandatory": "#mandatory_#page_user_1##",
            "field_type": "text",
            "field_value": "#date_#page_user_1##"
          }
        ],
        "part_label": "To Adminster"
      }
    ]
  }


  function isValidDateFormat(value) {
    // Regular expression pattern
    var pattern = /^\d{4}-\d{2}-\d{2}$/;

    // Check if the value matches the pattern
    return pattern.test(value);
  }


  function updateFieldValue(formData, pageType, fieldId, officialValue) {
    //this is a function to link form_official_result to final_result form_official_status to official_status
    console.log('running updateFieldValue final result', officialValue);
    // Find the object with the specified page_type
    var customPageObject = formData.pages.find(function (page) {
      return page.page_type === pageType;
    });

    // If the custom page object is found
    if (customPageObject) {
      console.log('has custom page object')
      // Find the field with the specified field_id and update its field_value
      var fieldToUpdate = customPageObject.parts[0].fields.find(function (field) {
        console.log('found field id', fieldId)
        return field.field_id === fieldId;
      });

      if (fieldToUpdate) {
        console.log(fieldToUpdate)
        console.log('has custom field to update status', officialValue)
        fieldToUpdate.field_value = officialValue;
      }
    }

    return formData;
  }


  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const generateAdminObj = (multiple_index, base_obj, newLabel, fieldMultipleType = null) => {
    console.log('generateAdminObj')
    let newFormElements = { ...formElements };

    const original_AdminObj = newFormElements.pages.find((page) => {
      const parts = page.parts || [];
      for (const part of parts) {
        const fields = part.fields || [];
        for (const field of fields) {
          if (field.field_id === `sign_date_${multiple_index}`) {
            return true; // Found the desired object
          }
        }
      }
      return false; // Desired object not found
    });
    const sign_date_fields = original_AdminObj?.parts[0].fields
    const sign_date_field = sign_date_fields?.find(f => f.field_id === `sign_date_${multiple_index}`);


    if (isValidDateFormat(sign_date_field?.field_value)) {
      return original_AdminObj
    }
    let obj = { ...base_obj };

    if (fieldMultipleType) {

      obj.page_multiple_type = fieldMultipleType
    }

    obj.page_label = capitalize(newLabel.split(' ')[1]);

    obj.parts[0].part_label = newLabel;


    obj.parts[0].fields.forEach(field => {



      field['field_id'] = field['field_id'].replace(/_\d+$/, `_${multiple_index}`);
      field.field_label = field.field_label.replace(/(\d+)/, multiple_index);
      if (field.field_mandatory) {
        field.field_mandatory = `#mandatory_#page_user_${multiple_index}##`;

      }

      if (field.field_disabled_approver) {
        field.field_disabled_approver = field.field_disabled_approver.replace(/_\d+#/, `_${multiple_index}#`);
      }

      if (field.field_value) {
        field.field_value = field.field_value.replace(/_\d+#/, `_${multiple_index}#`);
      }


      if (field.field_options) {

        // const pastTense = obj.page_label + "ed";
        const pastTense = tensify(obj.page_label).past;

        field.field_options.forEach((option) => {
          if (option.option_label === "Pending" || option.option_label === "Holding" || option.option_label === "Returned") {
            // do nothing
          } else if (option.option_label.includes("Not")) {
            option.option_label = "Not " + pastTense;
          } else {
            option.option_label = pastTense;
          }
        });
      }




    });



    obj.page_user = obj.page_user.replace(/_\d+#/, `_${multiple_index}#`);
    return obj;
  };


  useEffect(() => {
    if (download == 1) {
      window['export2pdf'](formId)

    }
  }, [])




  useEffect(() => {

    // if (typeof formId == 'undefined') return;



    async function fetchData() {

      try {

        let res;

        let paramsstring = '';
        if (pageType != null) {
          paramsstring += `&pageType=${pageType}`;
        }
        if (applicantId != null) {
          paramsstring += `&applicantId=${applicantId}`;
        }
        //

        res = await fetch(`https://eform.hsu.edu.hk/form/action/selectForm.php?formId=${formId}` + paramsstring);
        //


        const { data, status } = await res.json()
        //  alert(status)
        if (status == 'fail') {
          window.location.href = 'https://ecampus.hsu.edu.hk/login/logout';
        }

        if (status == 'login') {
          window.location.href = `https://ecampus.hsu.edu.hk/login/?url_redirect=https://eform.hsu.edu.hk/form/dev/?formId=${formId}`;
        }

        const { id, submitId, submitTime, form_status, form_nav_enable,
          form_back, form_admin, form_officer,
          form_approval_index, form_user_lock,
          form_page_type, form_official_page, form_user_page,
          form_admin_progress, pages, form_custom_enable,
          form_admin_note_enable, form_captcha, form_url, form_print_enable, form_nav_label, form_multiple_type,
          form_chat_person, form_officers
        } = data[0]
        const customJSON = pages.filter(page => page.page_type == "custom")[0]
        //
        console.log('data[0]', data[0])

        setCustomPages(customJSON)
        setId(id)
        setSubmitId(submitId)
        setSubmitTime(submitTime)
        setFormStatus(form_status)
        setFormBar(form_nav_enable)
        setFormBack(form_back)
        setFormAdmin(form_admin)
        setFormOfficer(form_officer)
        setFormApprovalIndex(form_approval_index)
        setFormUserLock(form_user_lock)
        setFormPageType(form_page_type)
        setFormUserPage(form_user_page)
        setFormAdminProgress(form_admin_progress)
        setFormOfficialPage(form_official_page)
        setFormCustomEnable(form_custom_enable)
        setFormAdminNoteEnable(form_admin_note_enable)
        setFormCaptchaEnable(form_captcha == undefined ? true : form_captcha)
        setFormUrl(form_url)
        setFormPrintEnable(form_print_enable)
        setFormNavLabel(form_nav_label)
        setFormMultipleType(form_multiple_type)
        setFormChatPerson(form_chat_person)
        setFormOfficers(form_officers)
        // setFormLabel(form_label)
        console.log('form_chat_person', form_chat_person)



        if (form_page_type === "official") {
          setCurrentPageIndex(pageIndex ? pageIndex - 1 : (form_approval_index > form_official_page ? form_official_page - 1 : form_approval_index - 1))

        } else {
          setCurrentPageIndex(0)
        }
        if (form_status === 'Submitted') {
          setDisableField(true)

        } else {
          setDisableField(false)

        }

        if (!data) {
          window.location.href = 'https://eform.hsu.edu.hk/form/?status=fail';

        }

        if (pageType == "custom") {

          var customFormData = updateFieldValue(data[0], "custom", "final_result", data[0].form_official_result);
          customFormData = updateFieldValue({ ...customFormData }, "custom", "official_status", data[0].form_official_status);
          console.log('custom form elements1 ', JSON.stringify(customFormData))

          setCustomPages(customFormData.pages.filter(page => page.page_type == "custom")[0])



        } else {
          // setFormElements(data[0])
        }

        const fetchedFormElments = data[0]
        const officerLabelField = {
          "field_label": "<h6 class=\"bg-light py-1 my-3\">Please specify officer(s).</h6>",
          "field_type": "description"
        };

        const officerRecipientField = {
          "field_autocomplete": "User",
          "field_column": "col-sm-6",
          "field_id": `user_approver_${form_approval_index}`,
          "field_label": "Recipient",
          "field_mandatory": "yes",
          "field_multiple_id": "mapprover",
          "field_multiple_index": form_approval_index,
          "field_multiple_type": "mapprover_officer",
          "field_type": "text"
        };

        const officerActionField = {
          "field_column": "col-sm-6",
          "field_id": `user_action_${form_approval_index}`,
          "field_label": "Action",
          "field_mandatory": "yes",
          "field_multiple_id": "mapprover",
          "field_multiple_index": form_approval_index,
          "field_multiple_type": "mapprover_officer",
          "field_multiple_primary": "yes",
          "field_options": [
            {
              "option_label": "To check"
            },
            {
              "option_label": "To confirm"
            },

          ],
          "field_type": "select"
        };


        const externalLabelField = {
          "field_label": "<h6 class=\"bg-light py-1 my-3\">Please specify senior approver(s).</h6>",
          "field_type": "description"
        };
        const externalRecipientField = {
          "field_autocomplete": "User",
          "field_column": "col-sm-6",
          "field_id": `user_approver_${form_official_page + 1}`,
          "field_label": "Recipient",
          "field_mandatory": "yes",
          "field_multiple_id": "mapprover",
          "field_multiple_index": form_official_page + 1,
          "field_multiple_type": "mapprover_external",
          "field_type": "text"
        }
        const externalActionField = {
          "field_column": "col-sm-6",
          "field_id": `user_action_${form_official_page + 1}`,
          "field_label": "Action",
          "field_mandatory": "yes",
          "field_multiple_id": "mapprover",
          "field_multiple_index": form_official_page + 1,
          "field_multiple_type": "mapprover_external",
          "field_multiple_primary": "yes",
          "field_options": [
            {
              "option_label": "To endorse"
            },
            {
              "option_label": "To approve"
            }
          ],
          "field_type": "select"
        }
        const externalActionFieldWithoutPrimary = {
          "field_column": "col-sm-6",
          "field_id": `user_action_${form_official_page + 1}`,
          "field_label": "Action",
          "field_mandatory": "yes",
          "field_multiple_id": "mapprover",
          "field_multiple_index": form_official_page + 1,
          "field_multiple_type": "mapprover_external",
          "field_options": [
            {
              "option_label": "To endorse"
            },
            {
              "option_label": "To approve"
            }
          ],
          "field_type": "select"
        }

        if (form_multiple_type === 'mapprover_officer' || form_multiple_type === 'mapprover_external') {
          const part = fetchedFormElments.pages[0].parts.find(part =>
            part.fields.find(field => field.field_id === 'user_approver_1') || part.part_id === 'mapprover'  
          );
          const partIndex = fetchedFormElments.pages[0].parts.findIndex(part =>
            part.fields.find(field => field.field_id === 'user_approver_1') || part.part_id === 'mapprover' 
          );
          // const part = fetchedFormElments.pages[0].parts.find(part =>
          //   part.fields.find(field => field.field_id === 'user_approver_1') 
          // );
          // const partIndex = fetchedFormElments.pages[0].parts.findIndex(part =>
          //   part.fields.find(field => field.field_id === 'user_approver_1') 
          // );


          if (part) {
            console.log('part found', part);
            if (form_multiple_type === 'mapprover_officer') {

              fetchedFormElments.pages[0].parts[partIndex].fields.push(
                officerLabelField,
                officerRecipientField,
                officerActionField
              );
            } else if (form_multiple_type === 'mapprover_external') {
              // fetchedFormElments.form_official_page += 1;
              console.log('mapprover_external part', fetchedFormElments.pages[0].parts[partIndex])

              const fetchedFields = fetchedFormElments.pages[0].parts[partIndex].fields
              console.log('fetchedFields', fetchedFields)

              let hasFieldWithMultipleType = fetchedFields.some(

                (obj) => obj.field_multiple_type === "mapprover_external"
              );


              console.log('hasFieldWithMultipleType', hasFieldWithMultipleType)

              if (!hasFieldWithMultipleType) {
                fetchedFormElments.pages[0].parts[partIndex].fields.push(
                  externalLabelField,
                  externalRecipientField,
                  externalActionField
                );
              } else {
                // fetchedFormElments.pages[0].parts[partIndex].fields.push(
                //   externalRecipientField,
                //   externalActionFieldWithoutPrimary
                // );
              }
              // fetchedFormElments.pages[0].parts[partIndex].fields.push(
              //   externalLabelField,
              //   externalRecipientField,
              //   externalActionField
              // );
            }

          }
        } else if (form_multiple_type === 'mapprover_external') {
          const part = fetchedFormElments.pages[0].parts.find(part =>
            part.fields.find(field => field.field_id === 'user_approver_1')
          );
          const partIndex = fetchedFormElments.pages[0].parts.findIndex(part =>
            part.fields.find(field => field.field_id === 'user_approver_1')
          );

          if (part) {
            console.log('part found', part);
            fetchedFormElments.pages[0].parts[partIndex].fields.push(
              { user: "Joe Doe" }
            );
          }
        }
        if (form_multiple_type == 'mapprover_officer') {
          const part = fetchedFormElments.pages[0].parts.find((part) =>
            part.fields.find((field) => field.field_id === 'user_approver_1')

          );
          const partIndex = fetchedFormElments.pages[0].parts.findIndex((part) =>
            part.fields.find((field) => field.field_id === 'user_approver_1')
          );

          if (part) {

            console.log('part found', part)
            fetchedFormElments.pages[0].parts[partIndex].fields.push()
          }
        }
        console.log('fetchedFormElements', fetchedFormElments)

        setFormElements(fetchedFormElments)



      } catch (error) {


        let res = await fetch(`https://eform.hsu.edu.hk/form/action/selectForm.php?formId=${formId}`)
        const { status, url } = await res.json()
        if (status == 'fail') {
          window.location.href = 'https://ecampus.hsu.edu.hk/login/logout';
        }

        if (status == 'login') {
          window.location.href = `https://ecampus.hsu.edu.hk/login/?url_redirect=https://eform.hsu.edu.hk/form/dev/?formId=${formId}`;
        }

        if (status == 'redirect') {
          window.location.href = url
        }
         


      }
      // ...

    }

    fetchData();



  }, [formId, formStatus])



  const pushRemoveArray = (pushArray, removeArray, field_ids) => {
    pushArray.push(...field_ids)
    removeArray.filter(function (el) {
      return !field_ids.includes(el)
    })
  }

  const handleRemoveLastField = (id) => {
    // alert(`id : ${id}`);
    // alert(`form approval index ${formApprovalIndex}`);

    const newFormElements = { ...formElements };
    let pageIndex;

    switch (formPageType) {
      case 'official':
        pageIndex = formUserPage + currentPageIndex;
        break;
      case 'custom':
        pageIndex = formUserPage + formOfficialPage + currentPageIndex;
        break;
      default:
        pageIndex = currentPageIndex;
        break;
    }

    const part = newFormElements.pages[pageIndex].parts.find((part) =>
      part.fields.find((field) => field.field_id === id)
    );


    if (part) {


      const findMultipleIndexesWithPrimary = (fields) => {
        const multipleIndexes = [];
        for (const field of fields) {
          if (field.field_multiple_primary === "yes") {
            multipleIndexes.push(field.field_multiple_index);
          }
        }
        return multipleIndexes
      };




      const multipleIndexWithPrimary = findMultipleIndexesWithPrimary(part.fields);
      console.log('multipleIndexWithPrimary', multipleIndexWithPrimary);
      console.log('multipleIndexWithPrimary part', part);

      const fieldIndex = part.fields.findIndex((field) => field.field_id === id);
      const fieldToRemove = part.fields[fieldIndex];
      const sameMultipleIdFields = part.fields.filter((field) => field.field_multiple_id === fieldToRemove.field_multiple_id);
      const maxIndex = Math.max(...sameMultipleIdFields.map((field) => field.field_multiple_index));

      if (maxIndex > 1 && maxIndex >= formApprovalIndex) {


        const fieldsToRemove = sameMultipleIdFields.filter((field) => field.field_multiple_index === maxIndex && !multipleIndexWithPrimary.includes(field.field_multiple_index)
        );
        fieldsToRemove.forEach(field => {
          const indexToRemove = part.fields.indexOf(field);
          part.fields.splice(indexToRemove, 1);
        });
      }
    }
    setFormOfficialPage(formOfficialPage - 1);
    // alert(formOfficialPage);
    const field = part.fields.find(f => f.field_id === `user_approver_${formApprovalIndex}`);
    if (field) {
      // alert(`form approval officer ${field.field_value}`);
      newFormElements.form_approval_officer = field.field_value;
    } else {
      newFormElements.form_approval_officer = ""
    }
    newFormElements.form_official_page = formOfficialPage + 1;
    setFormElements(newFormElements);
  };


  function getStaffByApprovalIndex(jsonData, fieldId) {
    const data = JSON.parse(jsonData);

    for (const page of data) {
      for (const part of page.parts) {
        const field = part.fields.find(f => f.field_id === fieldId);
        if (field) {
          return field.field_value;
        }
      }
    }

    return null;
  }


  const handleAddField = (id) => {
    let i = 1;
    const newFormElements = { ...formElements };
    // setFormOfficialPage(formOfficialPage+1)
    // newFormElements.form_official_page = formOfficialPage +1
    let pageIndex;
    switch (formPageType) {
      case 'official':
        pageIndex = formUserPage + currentPageIndex;
        break;
      case 'custom':
        pageIndex = formUserPage + formOfficialPage + currentPageIndex;
        break;
      default:
        pageIndex = currentPageIndex;
        break;
    }

    const part = newFormElements.pages[pageIndex].parts.find((part) =>
      part.fields.find((field) => field.field_id === id)
    );



    if (part) {
      const sortedFields = part.fields.sort((a, b) => a.field_multiple_index - b.field_multiple_index);
      const fieldIndex = sortedFields.findIndex((field) => field.field_id === id);
      const fieldToDuplicate = sortedFields[fieldIndex];
      const sameMultipleIdFields = sortedFields.filter((field) => field.field_multiple_id === fieldToDuplicate.field_multiple_id);
      const maxIndex = Math.max(...sameMultipleIdFields.map((field) => field.field_multiple_index));
      const sameMultipleIdFieldsWithMaxIndex = sameMultipleIdFields.filter((field) => field.field_multiple_index === maxIndex);
      const modifiedSameMultipleIdFields = sameMultipleIdFieldsWithMaxIndex.map(({ field_multiple_primary, field_value, field_disabled,...rest }) => ({
        ...rest,
        field_multiple_index: rest.field_multiple_index + 1,
        field_id: rest.field_id.replace(/\d+$/, '') + (rest.field_multiple_index + 1),
      }));

      let insertIndex = fieldIndex + 1;
      for (let i = insertIndex; i < sortedFields.length; i++) {
        if (sortedFields[i].field_multiple_index < modifiedSameMultipleIdFields[0].field_multiple_index) {
          insertIndex = i + 1;
        } else {
          break;
        }
      }
      // alert(formOfficialPage+1)

      part.fields.splice(insertIndex, 0, ...modifiedSameMultipleIdFields);
    }
    setFormOfficialPage(formOfficialPage + 1);
    const field = part.fields.find(f => f.field_id === `user_approver_${formApprovalIndex}`);

    if (field) {
      // alert(`form approval officer ${field.field_value}`);
      newFormElements.form_approval_officer = field.field_value;
    } else {
      newFormElements.form_approval_officer = ""
    }
    newFormElements.form_official_page = formOfficialPage + 1;
    setFormElements(newFormElements);
    console.log('Add newFormElements', newFormElements)
  };


  const handleChangeInput = (id, event, filename = '', text = '') => {

    //

    const newFormElements = { ...formElements };

    // const pageIndex = formPageType == 'official' ? formUserPage + currentPageIndex : currentPageIndex
    let pageIndex;
    switch (formPageType) {
      case 'official':
        pageIndex = formUserPage + currentPageIndex;
        break;
      case 'custom':
        pageIndex = formUserPage + formOfficialPage + currentPageIndex;
        break;

      default:
        pageIndex = currentPageIndex;
        break;
    }
    //
    let [app_option_invisible_true, app_option_invisible_false, app_option_mandatory_yes, app_option_mandatory_no] = [[], [], [], []];

    newFormElements.pages[pageIndex].parts.forEach(element => {



      element.fields.forEach(field => {

        // app_option_invisible_true.includes(field.field_id) && (field.field_invisible = true; delete field.field_value;);
        if (app_option_invisible_true.includes(field.field_id)) {
          field.field_invisible = true;
          delete field.field_value;
        }
        app_option_invisible_false.includes(field.field_id) && (field.field_invisible = false);
        app_option_mandatory_yes.includes(field.field_id) && (field.field_mandatory = "yes");
        app_option_mandatory_no.includes(field.field_id) && (field.field_mandatory = "no");

        let option = {}


        if (id === field.field_id) {
          switch (field.field_type) {
            case 'number':
              field['field_value'] = event.target.value;
              // Update field_price if it exists
              if (field.hasOwnProperty('field_price') && event.target.price !== undefined) {
                field['field_price'] = Number(event.target.price) || 0;
              }
              break;
  
            case 'date':
              if (!field.hasOwnProperty('field_value') || field['field_value'] == "") {
                //
                field['field_value'] = moment().format('YYYY-MM-DD');
              }
              else {
                field['field_value'] = event.target.value;

              }

              if (field['field_value'].length == 0) {
                delete field['field_value']
              }



              break;

            case 'checkbox':
              field['field_value'] = event.target.checked;
              break;
            case 'upload':
              field['field_value'] = filename;
              if (event.target.files && event.target.files.length > 0) {
                field['field_filename'] = event.target.files[0].name;

              }
              if (filename == '') {
                delete field['field_filename'];
              }
              break;
            case 'checkboxes':
              option = JSON.parse(event.target.value)


              if (!field['field_value']) {
                field['field_value'] = [];
              }
              if (!field['field_options_checked_array']) {
                field['field_options_checked_array'] = [];
              }


              // field['field_value'] = event.target.checked;
              if (field['field_value'].includes(option.option_label)) {

                // alert(`${option.option_label} uncheck`)
                field['field_value'] = field['field_value'].filter(value => value !== option.option_label)
                //
                field['field_options_checked_array'] = field['field_options_checked_array'].filter(obj => obj.option_label != option.option_label)

                if (option.option_uncheck?.option_invisible_false?.length > 0) {
                  pushRemoveArray(app_option_invisible_false, app_option_invisible_true, option.option_uncheck.option_invisible_false)
                }
                if (option.option_uncheck?.option_invisible_true?.length > 0) {
                  pushRemoveArray(app_option_invisible_true, app_option_invisible_false, option.option_uncheck.option_invisible_true)
                }
                if (option.option_uncheck?.option_mandatory_yes?.length > 0) {
                  pushRemoveArray(app_option_mandatory_yes, app_option_mandatory_no, option.option_uncheck.option_mandatory_yes)
                }
                if (option.option_uncheck?.option_mandatory_no?.length > 0) {
                  pushRemoveArray(app_option_mandatory_no, app_option_mandatory_yes, option.option_uncheck.option_mandatory_no)
                }


              } else {

                //if the option is not included before , push into the option array.
                field['field_value'].push(option.option_label);

                field['field_options_checked_array'].push(option)

                // if (option.option_invisible_false?.length>0) {
                //   pushRemoveArray(app_option_invisible_true,app_option_invisible_false,option.option_invisible_false)
                // }
                // if (option.option_invisible_true?.length>0) {
                //   pushRemoveArray(app_option_invisible_false,app_option_invisible_true,option.option_invisible_true)
                // }
                // if (option.option_mandatory_yes?.length>0) {
                //   pushRemoveArray(app_option_mandatory_no,app_option_mandatory_yes,option.option_mandatory_no)

                // }
                // if (option.option_mandatory_no?.length>0) {
                //   pushRemoveArray(app_option_mandatory_yes,app_option_mandatory_no,option.option_mandatory_yes)

                // }


              }
              if (field['field_value'].length == 0) {
                delete field['field_value']
              }



              field['field_options_checked_array'].forEach(option => {
                if (option.option_invisible_false?.length > 0) {
                  pushRemoveArray(app_option_invisible_false, app_option_invisible_true, option.option_invisible_false)
                }
                if (option.option_invisible_true?.length > 0) {
                  pushRemoveArray(app_option_invisible_true, app_option_invisible_false, option.option_invisible_true)
                }
                if (option.option_mandatory_yes?.length > 0) {
                  pushRemoveArray(app_option_mandatory_yes, app_option_mandatory_no, option.option_mandatory_yes)
                }
                if (option.option_mandatory_no?.length > 0) {
                  pushRemoveArray(app_option_mandatory_no, app_option_mandatory_yes, option.option_mandatory_no)
                }
                // if(field['field_options_checked_array'].length === 0){
                //   
                //   app_option_invisible_false = []
                //   app_option_invisible_true = []
                //   app_option_mandatory_yes = []
                //   app_option_mandatory_no = []
                //   
                //   
                //   
                //   
                // }
              })



              // 
              //   
              //    
              //  
              break;

            case 'select':
              option = JSON.parse(event.target.value)

              field['field_value'] = option.option_label;

              if (option.option_invisible_false?.length > 0) {
                pushRemoveArray(app_option_invisible_false, app_option_invisible_true, option.option_invisible_false)
              }
              if (option.option_invisible_true?.length > 0) {
                pushRemoveArray(app_option_invisible_true, app_option_invisible_false, option.option_invisible_true)
              }
              if (option.option_mandatory_yes?.length > 0) {
                pushRemoveArray(app_option_mandatory_yes, app_option_mandatory_no, option.option_mandatory_yes)
              }
              if (option.option_mandatory_no?.length > 0) {
                pushRemoveArray(app_option_mandatory_no, app_option_mandatory_yes, option.option_mandatory_no)
              }

              // if (field['field_multiple_id']==="mapprover") {
              //   console.log('mapprover detected')
              //   const newObj  = generateAdminObj(field['field_multiple_index'],baseAdminObj,field['field_value'])
              //   console.log('field multiple index',field['field_multiple_index'])
              //   console.log('newObj',newObj)
              // }

              break;
            case 'radio':
              option = JSON.parse(event.target.value)
              field['field_value'] = option.option_label;

              if (option.option_invisible_false?.length > 0) {
                pushRemoveArray(app_option_invisible_false, app_option_invisible_true, option.option_invisible_false)
              }
              if (option.option_invisible_true?.length > 0) {
                pushRemoveArray(app_option_invisible_true, app_option_invisible_false, option.option_invisible_true)
              }
              if (option.option_mandatory_yes?.length > 0) {
                pushRemoveArray(app_option_mandatory_yes, app_option_mandatory_no, option.option_mandatory_yes)
              }
              if (option.option_mandatory_no?.length > 0) {
                pushRemoveArray(app_option_mandatory_no, app_option_mandatory_yes, option.option_mandatory_no)
              }
              break;

            default:
              // field['field_value'] = DOMPurify.sanitize(event.target.value);
              field['field_value'] = event.target.value;
              break;
          }
        }
        // app_option_invisible_true.includes(field.field_id) ? (field.field_invisible = true):(field.field_invisible = false);
        // app_option_invisible_false.includes(field.field_id) && (field.field_invisible = false);
        // app_option_mandatory_yes.includes(field.field_id) ? (field.field_mandatory = "yes"):(field.field_mandatory = "no");
        // app_option_mandatory_no.includes(field.field_id) && (field.field_mandatory = "no");
        // 
        // 
        // 
        // 
      })
    })
    //
    console.log('newFormElements', newFormElements)
    setFormElements(newFormElements);

  }
  function replaceObjectInArray(originalArray, property, value, newArray) {
    console.log('replaceObjectInArray')
    const index = originalArray.findIndex((obj) => obj[property] === value);
    const customPages = originalArray.find(item => item.page_type === "custom");
    console.log('originalArray', originalArray);
    console.log(originalArray.slice(index + 1));
    console.log(originalArray.slice(0, index));
    if (index !== -1) {
      const updatedArray = [
        ...originalArray.slice(0, index),
        ...newArray

        // ...originalArray.slice(index + 1),
      ];
      updatedArray.push(customPages)
      return updatedArray;
    } else {

      return originalArray;
    }
  }

  const handleCheckAdminPages = () => {

    const newFormElements = { ...formElements };
    const { pages } = newFormElements;
    let mapproverFields = [];
    let adminObjArray = [];
    pages.forEach(page => {
      const { parts } = page
      parts.forEach(part => {
        const { fields } = part
        fields.forEach(field => {
          if (field.field_multiple_id === "mapprover" && field.field_type === "select") {
            console.log('mfield', field)
            let { field_value, field_multiple_index, field_multiple_type } = field;
            mapproverFields.push({ field_value, field_multiple_index, field_multiple_type });
          }

        })
      })

    })


    mapproverFields.forEach(field => {

      console.log('mapprover field', field)
      const newObj = generateAdminObj(field['field_multiple_index'], baseAdminObj, field['field_value'], field['field_multiple_type'])
      const index = adminObjArray.findIndex(obj => obj.field_multiple_index === field['field_multiple_index']);

      console.log('admin_obj')
      // console.log('admin_new_obj',newObj)
      if (index !== -1) {


        // Object with the same field_multiple_index already exists, replace it
        adminObjArray[index] = JSON.parse(JSON.stringify(newObj));
      } else {
        // Object doesn't exist, push it to the array
        adminObjArray.push(JSON.parse(JSON.stringify(newObj)));
      }
      // adminObjArray.push(JSON.parse(JSON.stringify(newObj)))

    }



    )
    if (mapproverFields.length) {
      let newPagesArray = replaceObjectInArray(pages, "page_type", "official", adminObjArray)
      newFormElements.pages = newPagesArray

      newFormElements.form_official_page = mapproverFields.length
    }
    return newFormElements

  };

  const handleSubmit = (e) => {
    return new Promise((resolve, reject) => {
      e.preventDefault();
      const errors = [];
      const { pages } = formElements;
      let isValid = true;
      let isPending = false;
      let emailValid = true;
      let autoCompleteUserValid = true;
      let noScript = true;
  
      pages.forEach(page => {
        const { parts } = page;
        parts.forEach(part => {
          const { fields } = part;
          fields.forEach(field => {
            if (field.field_mandatory === "yes" && !field.field_value) {
              isValid = false;
              return;
            }
            if (field.field_mandatory === 'yes' && field.field_value === 'Pending' && field.field_id===`official_status_${formApprovalIndex}`) {
              isPending = true
              return;
            }

          });
        });
      });
  
      pages.forEach(page => {
        const { parts } = page;
        parts.forEach(part => {
          const { fields } = part;
          fields.forEach(field => {
            if (field.hasOwnProperty('field_value') && field.field_type === "email" && !EmailValidator.validate(field.field_value) && (field.field_value.trim() !== '')) {
              emailValid = false;
              return;
            }
          });
        });
      });
  
      pages.forEach(page => {
        const { parts } = page;
        parts.forEach(part => {
          const { fields } = part;
          fields.forEach(field => {
            if (field.hasOwnProperty('field_value') && field.field_autocomplete === "User" && field.field_value.trim() !== "" && !(field.field_value.trim().endsWith("@hsu.edu.hk") || field.field_value.trim().startsWith('#sign_'))) {
              autoCompleteUserValid = false;
              return;
            }
          });
        });
      });
  
      pages.forEach(page => {
        const { parts } = page;
        parts.forEach(part => {
          const { fields } = part;
          fields.forEach(field => {
            const hasInvalidChars = /[<>]/gi.test(field.field_value);
            const hasScript = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi.test(field.field_value);
            if (hasInvalidChars || hasScript) {
              noScript = false;
              return;
            }
            if (field?.field_multiple_id === "mapprover") {
              fields.field_value = fields.field_value?.trim();
            }
          });
        });
      });
  
      if (!noScript) {
        errors.push('You are not allowed to input scripts and symbols such as < and >');
      }
  
      if (!isValid) {
        errors.push("Please fill-in compulsory fields.");
      }
  
      if (!emailValid) {
        errors.push("Please fill-in correct email format.");
      }
      if (isPending) {
        errors.push("The status is still pending.")
      }
      if (!autoCompleteUserValid) {
        errors.push("Please fill-in a person with a valid HSUHK email.");
      }
  
      if (errors.length > 0) {
        const errorString = errors.join("\n");
        setIsFormValid(false);
        alert(errorString);
        reject(errors); // Reject the promise with errors
      } else {
        setIsFormValid(true);
        let newFormElements = { ...formElements };
  
        if (formStatus !== "Submitted" || formPageType === "user") {
          const part = newFormElements.pages[currentPageIndex].parts.find(part =>
            part?.fields?.find(field => field.field_id === 'user_approver_1')
          );
  
          const field = part?.fields.find(f => f.field_id === `user_approver_${formApprovalIndex}`);
  
          newFormElements = handleCheckAdminPages();
          newFormElements.form_approval_officer = field?.field_value || "";
          setFormElements(newFormElements);
        }
  
        const mapprover_officer_part = newFormElements.pages[currentPageIndex].parts.find(part =>
          part.fields.find(field =>
            field?.field_id?.startsWith("user_approver") &&
            field?.field_multiple_type === "mapprover_officer"
          )
        );
        const mapprover_external_part = newFormElements.pages[currentPageIndex].parts.find(part =>
          part.fields.find(field =>
            field?.field_id?.startsWith("user_approver") &&
            field?.field_multiple_type === "mapprover_external"
          )
        );
  
        const form_officers = [];
        const form_external = [];
  
        if (mapprover_officer_part) {
          mapprover_officer_part.fields.forEach(field => {
            if (
              field?.field_id?.startsWith("user_approver") &&
              field?.field_multiple_type === "mapprover_officer" &&
              field?.field_value
            ) {
              form_officers.push(field.field_value);
            }
          });
        }
  
        if (mapprover_external_part) {
          mapprover_external_part.fields.forEach(field => {
            if (
              field?.field_id?.startsWith("user_approver") &&
              field?.field_multiple_type === "mapprover_external" &&
              field?.field_value
            ) {
              form_external.push(field.field_value);
            }
          });
        }
  
        if (form_officers.length > 0) {
          newFormElements.form_officers = form_officers;
        }
  
        if (form_external.length > 0) {
          newFormElements.form_external = form_external;
        }
  
        console.log('form officers', form_officers);
        console.log('submit new form', newFormElements);
  
        axios.post('https://eform.hsu.edu.hk/form/action/submitForm.php', newFormElements)
          .then(function (response) {
            const { submitId, redirect } = response.data;
            console.log('redirect', redirect);
            setSubmitId(submitId);
  
            window.location.href = redirect.includes("?")
              ? `https://eform.hsu.edu.hk/form/${redirect}`
              : `https://eform.hsu.edu.hk/form/${redirect}?submitId=${submitId}`;
            resolve(); // Resolve the promise on successful submission
          })
          .catch(function (error) {
            reject(error); // Reject the promise on error
          });
      }
    });
  };
  

  return (

    <Router>
      <FormContext.Provider value={{
        formNavLabel, formPrintEnable, formUrl, formCaptchaEnable, formCustomEnable, customPages, pageType, formId, formAdminProgress, disableUserSaveBtn, setDisableUserSaveBtn, submitId, submitTime,
        setFormPagesDisplay, formPageType, formUserLock, formOfficer, formElements, setFormElements, currentPageIndex, setCurrentPageIndex, handleSubmit, handleChangeInput, handleAddField, handleRemoveLastField, handleCheckAdminPages,
        id, submitId, disableField, formStatus, formAdmin, formApprovalIndex, formAdminNoteEnable, formMultipleType, formChatPerson, formOfficers, isFormValid
      }}>
        {formBar && <Navbar formBar={formBar} formBack={formBack} formId={formId} />}

        <Switch>

          <Route exact path='/form/dev'
            render={(props) => (
              <Form {...props} formElements={formElements} />
            )

            }
          />


        </Switch>


      </FormContext.Provider>

    </Router>

  );
}

export default App;